import { Flex } from "@components/flex/flex";
import { AddContentField, FormValueKey, FormValueOptions } from "@components/formContentFields/formElementStyle";
import { FormFieldBase } from "@components/formContentFields/formFieldBase";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Form } from "antd";
import { formOptionFactory } from "@pages/addChallengesPage/factories";
import { DeleteFormField, FormItemFlex } from "@components/field/formConditionFieldStyle";
import { Field } from "@components/field/field";
import { DeleteOutlined } from "@ant-design/icons";

export class FormFieldCheckbox extends FormFieldBase {
    public renderBody() {
        const { index, property, deleteFormElement } = this.props;

        return (
            <React.Fragment>
                <FormItemFlex>
                    <Field
                        name={[index, "property"]}
                        required
                        initialValue={property}
                        {...this.sharedProps}
                        label={<FormattedMessage id="valueKey" />}

                    />
                    <DeleteFormField
                        as={DeleteOutlined}
                        onClick={deleteFormElement}
                    />
                </FormItemFlex>
                <Form.List name={[index, "options"]}>
                    {(fields, { add, remove, move }) => {
                        return (
                            <React.Fragment>
                                <FormValueKey>
                                    <FormValueOptions>
                                        {
                                            fields.map((option, i) => {
                                                return (
                                                    <FormItemFlex>
                                                        <Field
                                                            {...this.sharedProps}
                                                            name={[i, "value"]}
                                                            key={option.key}
                                                            label={<FormattedMessage id="valueKey" />}
                                                        />
                                                        <DeleteFormField
                                                            as={DeleteOutlined}
                                                            onClick={() => remove(i)}
                                                        />
                                                    </FormItemFlex>
                                                );
                                            })
                                        }
                                    </FormValueOptions>
                                </FormValueKey>
                                <Flex
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <AddContentField
                                        onClick={() => add(formOptionFactory(fields.length))}
                                    >
                                        <FormattedMessage id="addCheckbox" />
                                    </AddContentField>
                                </Flex>
                            </React.Fragment>
                        );
                    }}
                </Form.List>
            </React.Fragment>
        );
    }
}
